import { Cell, Grid, ResponsiveTableRow, Separator, H4 } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import { getLastPathElement, getNumericalIdFromId } from '../../../util/StringUtil'
import { CtrLink } from '../../app/Links'
import TempleLabel from '../../common/TempleLabel'

export default function OwsCtrList({ ctrList, temples }) {
  const { t } = useTranslation()
  if (ctrList === undefined || ctrList.length === 0) {
    return null
  }
  return (
    <div id="OWS CTRs">
      <H4 size="H5" supplementary>
        {t('ows.ctrList.certifiedTempleRecords', 'Certified Temple Records')}
      </H4>
      <Separator size="nano" />
      <Grid>
        <p columns={1} />
        <Cell columns={11}>
          <DmcResponsiveTable
            atSizeColumns={{
              default: {
                labels: [
                  t('ctrId', 'CTR ID'),
                  t('temple.label', 'Temple'),
                  t('status.label', 'Status'),
                  t('type', 'Type'),
                  t('date', 'Date'),
                ],
              },
            }}
            totalColumnCount={5}
          >
            {ctrList.map((ctr) => {
              const ctrId = ctr.id?.split('.')[1] || ctr.id
              return (
                <ResponsiveTableRow
                  key={ctrId}
                  column1={
                    <>
                      <CtrLink ctrId={ctrId} /> ({getNumericalIdFromId(ctrId)})
                    </>
                  }
                  column2={temples && <TempleLabel temple={temples[ctr.templeRef?.templeCode]} />}
                  column3={getLastPathElement(ctr.ordinanceStatus)}
                  column4={getLastPathElement(ctr.ordinanceType)}
                  column5={ctr.performedDate?.original}
                />
              )
            })}
          </DmcResponsiveTable>
        </Cell>
      </Grid>
      <Separator />
    </div>
  )
}
